export class GMServiceVisitByVinQueryParameters {
  bac?: string;
  destinationId?: string;
  endDate?: string;
  startDate?: string;

  constructor(obj?: GMServiceVisitByVinQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
